import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {MultiselectItem, MultiselectItems, SelectItem} from '../../core/interfaces/admin.interface';
import {MultiselectService} from '../../core/services/multiselect.service';
import {NgSelectComponent} from "@ng-select/ng-select";
import {Observable} from "rxjs";

@Component({
  selector: 'list-select',
  templateUrl: './list-select.component.html',
  styleUrls: ['./list-select.component.scss']
})
export class ListSelectComponent implements OnInit {
  @ViewChild("select")
  select: NgSelectComponent

  @Input() multiple = false;

  @Output() companySelect = new EventEmitter<number | number[]>();
  @Output() itemSelection = new EventEmitter<MultiselectItem>();
  @Output() loaded = new EventEmitter<MultiselectItem[]>();

  ds$: Observable<SelectItem[]>;

  selection: SelectItem | SelectItem[] = null;
  items: SelectItem[] = [];

  constructor(
    private multiselectService: MultiselectService,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef
  ) { }

  async ngOnInit() {
  }

  reset() {
  }


  setMultiselectSettings() {
    this.cdRef.detach();
    this.cdRef.reattach();
  }

}
